import React from 'react';

const AWS_Get_Started = () => {
  return (
    <div>
      <h1>AWS_Get_Started</h1>
      <p>This is the AWS_Get_Started component.</p>
    </div>
  );
};

export default AWS_Get_Started;
